var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWritingMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1773 4.70711C14.7868 4.31658 14.1536 4.31658 13.7631 4.70711L11.8973 6.57289L16.1859 10.8615L18.0517 8.99571C18.4422 8.60519 18.4422 7.97202 18.0517 7.5815L15.1773 4.70711ZM15.3282 11.7192L11.0396 7.43061L5.64229 12.8279C5.30419 13.166 5.09841 13.6141 5.06223 14.0908L4.85429 16.8317C4.80796 17.4424 5.31643 17.9509 5.92707 17.9045L8.66798 17.6966C9.14475 17.6604 9.59279 17.4546 9.93089 17.1165L15.3282 11.7192Z",
    fill: "#FFF7EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 14,
    height: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWritingMedium);
export default __webpack_public_path__ + "static/media/ic_writing_medium.dd1183806165805a5fcf8fb1b2e0c356.svg";
export { ForwardRef as ReactComponent };